export function initToTop() {
  jQuery(window).on('load', function() {
  $('#toTop').click(function(){
    window.scrollTo(0, 0, 1500);
  })

  });
}

export function initFooterObfuscated($) {
  // footer obfuscated

  obfuscated('#menu-footer li');

  function obfuscated(elem) {
    $(elem).each(function () {
      if($(this).hasClass('obfuscated')) {
        let link = $(this).find('a');
        let text = link.text()
        let href = link.attr('href');
  
        link.replaceWith($('<button>'+ text +'</button>').attr('onclick', "window.location='" + href + "'"));
      }
    });
  }
}
